export default {
  title: 'Mall Decoration',
  previewTitle: 'Mall Center',
  pageSetting: 'Page Settings',
  pageTitle: 'Page Title',
  pageTitlePlaceholder: 'Enter page title',
  defaultPageTitle: 'Personal Center',
  modules: 'Modules',
  moduleList: 'Module List',
  moduleConfig: 'Module Config',
  editText: 'Edit Text',
  editTextTitle: 'Edit Text',
  moduleNames: {
    Banner: 'Carousel',
    Picture: 'Image Showcase',
  },
  labelName: {
    pointName: 'Points',
  },
  // Top language version
  langSection: 'Language',
  langEnglish: 'English',
  langZhTw: '繁體中文',
  langZhCn: '简体中文',
  langJaJp: 'Japanese',
  // Right Tabs
  tabs: {
    title: 'Page Title',
    carousel: 'Carousel',
    showcase: 'Image Showcase',
  },
  delete: 'Delete',
  // Carousel
  image: 'Image',
  show: 'Show',
  hide: 'Hide',
  carouselTip:
    'Up to 5 images can be uploaded. When hidden, the upload entry is removed and the top images are not displayed on the client.',
  uploadImage: 'Upload Image',
  // Showcase
  layout: 'Layout',
  layoutAlone: 'Single Row',
  layoutBigOne: 'Big One Per Row',
  layoutStack2: 'Two Stacked Rows',
  unit: 'Unit',
  unitPlaceholder: 'Enter unit',
  // Preview fixed copy
  previewBack: 'Back',
  previewExchange: 'Exchange',
  previewAll: 'All',
  mockItemTitle: 'Product {index}',
  // Actions
  save: 'Save',
  saveSuccess: 'Saved successfully',
  syncConfig: 'Sync Config',
  syncConfigTitle: 'Sync Configuration',
  syncConfigDesc: 'Sync the configuration of the current language ({lang}) to:',
  syncConfigSuccess: 'Sync successful',
  formLabel: {
    isShow: 'Display',
    show: 'Show',
    hide: 'Hide',
    image: 'Image',
    layoutType: 'Layout Type',
    layoutAlone: 'Single Row',
    layoutBigOne: 'Big One Per Row',
    layoutStack2: 'Two Stacked Rows',
  },
};
